import { render, staticRenderFns } from "./EditPenaltyChargeNotice.vue?vue&type=template&id=18187666&scoped=true&"
import script from "./EditPenaltyChargeNotice.vue?vue&type=script&lang=js&"
export * from "./EditPenaltyChargeNotice.vue?vue&type=script&lang=js&"
import style0 from "./EditPenaltyChargeNotice.vue?vue&type=style&index=0&id=18187666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18187666",
  null
  
)

export default component.exports